const React = require("react");
const PropTypes = require("prop-types");

const Term = ({ children }) => <dt className="pane__list-term">{children}</dt>;

Term.propTypes = {
  children: PropTypes.node.isRequired,
};

module.exports = Term;
